<template>
	<div class="route_container">
		<!-- 页面内容切换 -->
		<!-- <van-pull-refresh v-model="refreshLoading" @refresh="onRefresh" :pulling-text="$t('home.t1')" :loosing-text="$t('home.t2')" :loading-text="$t('home.t3')"> -->
		<div class="content home">
			<van-tabs v-model="active" @change="onChangeTabBar" animated offset-top="50px" class="my_tabs" line-height="0" title-inactive-color="#000" title-active-color="#fff" background="#fff">
				<van-tab>
					<Home :key="keys[0]" ref="home" />
				</van-tab>
				<van-tab>
					<Ecny :key="keys[1]" ref="ecny" />
				</van-tab>
				<van-tab>
					<Code :key="keys[2]" ref="code" />
				</van-tab>
				<van-tab>
					<Shop :key="keys[3]" ref="shop" />
				</van-tab>
				<van-tab>
					<My :key="keys[4]" ref="my" />
				</van-tab>
			</van-tabs>
		</div>
		<!-- </van-pull-refresh> -->
		<!-- 底部导航 -->
		<TabBar :active="active" @tab-change="onChangeTabBar" />
	</div>
</template>

<script>
	import TabBar from "@/components/TabBar.vue";
	import Home from "@/views/HomeView.vue";
	import Ecny from "@/views/EcnyView.vue";
	import Code from "@/views/CodeView.vue";
	import Shop from "@/views/ShopView.vue";
	import My from "@/views/MyView.vue";
	export default {
		components: {
			TabBar,
			Home,
			Ecny,
			Code,
			Shop,
			My,
		},
		data() {
			return {
				active: 0, //导航栏下标
				tabRef: ["home", "ecny", "code", "shop", "my"],
				keys: [0, 0, 0, 0, 0],
			};
		},
		computed: {
			storeActiveTab() {
				return this.$store.getters.getActiveTab;
			},
		},
		watch: {
			storeActiveTab(newVal) {
				if (newVal !== this.active) {
					this.active = newVal;
				}
			},
		},
		mounted() {
			// 初始化时同步store中的activeTab状态
			const storeTab = this.$store.getters.getActiveTab;
			if (storeTab !== this.active) {
				this.active = storeTab;
			}
			// 如果是code页面，则跳转到code页面
			if (this.$route.query.type === "code") {
				this.active = 2;
			}

			// 添加触摸事件防护，防止浏览器扩展冲突
			this.addTouchEventProtection();
		},

		methods: {
			onChangeTabBar(index) {
				console.log("当前tabbar下标", index);
				this.$emit("changeTab", index);
				this.active = index;
				// 更新store中的activeTab状态
				this.$store.dispatch("setActiveTab", index);
				// this.keys[index] += 1;	//重置tab组件的key
			},
			// 添加触摸事件防护，防止浏览器扩展冲突
			addTouchEventProtection() {
				// 确保触摸事件对象有正确的结构
				const originalAddEventListener = document.addEventListener;
				document.addEventListener = function (type, listener, options) {
					if (type === "touchstart" && typeof listener === "function") {
						const protectedListener = function (event) {
							try {
								// 确保事件对象有touches属性
								if (!event.touches) {
									event.touches = [];
								}
								if (!event.changedTouches) {
									event.changedTouches = [];
								}
								return listener.call(this, event);
							} catch (error) {
								// 静默处理扩展错误
								if (error.message && error.message.includes("length")) {
									console.log("浏览器扩展触摸事件错误已过滤");
									return;
								}
								throw error;
							}
						};
						return originalAddEventListener.call(this, type, protectedListener, options);
					}
					return originalAddEventListener.call(this, type, listener, options);
				};
			},
		},
	};
</script>

<style scoped lang="scss">
	.route_container {
		// padding-bottom: calc(env(safe-area-inset-bottom) + 10px);
		height: calc(100vh - 68px - env(safe-area-inset-bottom));
		overflow: hidden;
	}

	.banner_bj {
		width: 100%;
		max-width: 500px;
		position: fixed;
		top: 50px;
		z-index: 0;
	}

	.content {
		min-height: 100%;
	}
	.van-tabbar {
		max-width: var(--maxWidth);
		margin: auto;
		right: 0;
	}
	.dialog_table_box {
		min-height: 300px;
		height: fit-content;
		background-image: linear-gradient(0deg, #262623 0%, #33332f 100%);
		padding: 0 20px 20px;

		.title {
			font-family: PingFang-SC-Bold;
			font-size: 20px;
			color: #ffffff;
			line-height: 77px;
			text-align: center;
		}
		.title2 {
			font-family: PingFang-SC-Bold;
			font-size: 20px;
			color: #ffffff;
			text-align: center;
			padding-top: 24px;
		}
		.subTitle {
			font-family: PingFang-SC-Bold;
			font-size: 14px;
			color: #ffffff;
			text-align: center;
			margin-top: 4px;
			padding-bottom: 10px;
		}
		.rule {
			font-family: PingFang-SC-Medium;
			font-size: 13px;
			line-height: 21px;
			color: #b3aba1;
			> div.title {
				font-family: PingFang-SC-Bold;
				font-size: 14px;
				color: #ffffff;
				margin-bottom: 10px;
			}
		}
		.address_box {
			margin-top: 30px;
			display: flex;
			align-items: center;
			justify-content: center;
			gap: 10px;
			height: 44px;
			background-color: #383834;
			border-radius: 5px;
			font-family: PingFang-SC-Bold;
			font-size: 14px;
			color: #ffffff;
			.copy {
				width: 17px;
				height: 17px;
			}
		}

		.btn_box {
			margin-top: 37px;
			display: flex;
			justify-content: center;
			gap: 20px;
			.cancel_default_btn {
				flex: 1;
				font-family: PingFang-SC-Bold;
				font-size: 16px !important;
				color: #e0bf8f !important;
			}
			.confirm_default_btn {
				flex: 1;
				background-image: linear-gradient(0deg, #eacea1 0%, #d4aa77 100%);
				border-radius: 8px !important;
				border: none !important;
				font-size: 16px !important;
			}
		}
	}

	.subtotal {
		margin-top: 16px;
		background: none;
		border-radius: 6px;
		overflow: hidden;
		min-height: 200px;
		max-height: 500px;
		.tbody {
			max-height: calc(100vh - 500px);
			overflow: hidden;
			overflow-y: auto;
			min-height: 300px;
		}
		.tr,
		.th {
			display: flex;
			gap: 0 4px;
			justify-content: space-between;
			font-family: PingFang SC;
			font-weight: 400;
			font-size: 14px;
			min-height: 36px;
			padding: 2px 0;
			align-items: center;
			text-align: center;

			> div {
				flex: 3;
			}
			// > div:nth-child(1) {
			// 	flex: 4;
			// }
		}
		.th {
			background: #383834;
			> div > span {
				font-size: 14px;
				color: #b3aba1;
			}
		}
		.tr {
			font-family: PingFang-SC-Medium;
			font-size: 12px;
			font-weight: normal;
			font-stretch: normal;
			line-height: 18px;
			letter-spacing: 0px;
			color: #000;
		}

		.tr:nth-child(odd) {
			background: #30302c;
			color: #b3aba1;
		}
		.tr:nth-child(even) {
			background: #383834;
			color: #b3aba1;
		}

		.none {
			display: flex;
			flex-direction: column;
			height: fit-content;
			justify-content: center;
			align-items: center;
			margin-top: 40px;
			user-select: none;
			color: #999;
			padding-bottom: 40px;
			img {
				width: 120px;
				margin-bottom: 10px;
			}
		}
		.level_img {
			height: 16px;
			vertical-align: middle;
		}
		.released {
			color: #4caf50;
		}
		.unrelease {
			color: #2196f3;
		}
		.adv_release {
			color: #ffc107;
		}
	}
</style>
